import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  sensori: [],
  setSingleSensore:null,
  weatherData: {
    weatherData: [],
    lineGraph: [],
    locationTable: []
  },
  isLoading: false,
  error: null,
};
const sensoriSlice = createSlice({
  name: "sensori",
  initialState,
  reducers: {
    setSensori: (state, action) => {
      state.sensori = action.payload;
    },
    addSensori: (state, action) => {
      state.sensori.push(action.payload);
    },
    setSingleSensore: (state, action) => {
      // console.log("Updating Redux state with sensor data:", action.payload); // :white_check_mark: Check Redux update
      state.setSingleSensore = action.payload;
    },
    updateSensori: (state, action) => {
      const index = state.sensori.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.sensori[index] = action.payload;
      }
    },
    deleteSensori: (state, action) => {
      state.sensori = state.sensori.filter(
        (item) => item.id !== action.payload
      );
    },
    // weather
    setWeatherData: (state, action) => {
      state.weatherData = action.payload;
    },

    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});
export const {
  setSensori,
  addSensori,
  setSingleSensore,
  updateSensori,
  deleteSensori,
  setWeatherData,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
} = sensoriSlice.actions;
export const selectSensori = (state) => state.sensori?.sensori;
export const selectSingleSensori = (state) => state.sensori?.setSingleSensore;
export const selectWeatherData = (state) => state.sensori?.weatherData;
export const selectIsLoading = (state) => state.sensori?.isLoading;
export const selectError = (state) => state.sensori?.error;
export default sensoriSlice.reducer;